const IMAGE_PADDING_HORIZONTAL_PX = 30;

function calcImageWidth(contentWidth: string, columns: number) {
  return `calc((${contentWidth} - ${
    columns * IMAGE_PADDING_HORIZONTAL_PX
  }px) / ${columns})`;
}

export default function getBrandDishesImageSize(): string {
  return `
    (min-width: 75rem) ${calcImageWidth(`1000px`, 3)},
    (min-width: 640px) ${calcImageWidth(`100vw`, 3)},
    ${calcImageWidth(`100vw`, 1)}
  `;
}
